import AppConfig from "../AppConfig";
import * as UserErrorCodes from "../ErrorCodes/UserErrors";
import TAuth from "../screens/auth/Translations/TAuth";
import AuthUser from "./models/AuthUser";

const gtag_signup_conversion = (url = undefined) => {
    var callback = function () {
        if (typeof(url) !== 'undefined') {
            window.location = url;
        }
    };

    // @ts-ignore
    window.gtag('event', 'conversion', {
        'send_to': 'AW-850564176/BPlWCPuTyJEZENCoypUD',
        'event_callback': callback
    });

    return false;
}

export const GetAuthObject = (json: any = null) => {
    if (json) {
        if (json.user) {
            if(json.user.token)
                localStorage.setItem("token", json.user.token);

            localStorage.setItem("userID", json.user.id);
            localStorage.setItem("userName", json.user.userName);
            localStorage.setItem("email", json.user.email);
            localStorage.setItem("name", json.user.anU_NAME);
            localStorage.setItem("googleCreated", json.user.anU_GOOGLE_CREATED);

            if (json.user.aspNetRoles)
                localStorage.setItem("role", json.user.aspNetRoles.type);

            if (json.user.anU_USED_FREE_TRIAL)
                localStorage.setItem("usedFreeTrial", "true");

            if (json.user.hasPassword)
                localStorage.setItem("hasPassword", "true");

            if (json.user.anU_BUSINESS_ID)
                localStorage.setItem("businessID", json.user.anU_BUSINESS_ID);

            if (json.user.anU_TERMS_OF_SERVICE_ACCEPTED)
                localStorage.setItem("termsAccepted", "true");
        }

        if (json.subscription) {
            localStorage.setItem("subscriptionID", json.subscription.suB_ID);
            localStorage.setItem("subscriptionCode", json.subscription.suB_CODE);
        } else {
            localStorage.removeItem("subscriptionID");
            localStorage.removeItem("subscriptionCode");
        }

        if (json.totalRestaurants || json.totalRestaurants == 0)
            localStorage.setItem("totalRestaurants", json.totalRestaurants);

        if (json.defaultMenuID)
            localStorage.setItem("defaultMenuID", json.defaultMenuID);
    }

    const Auth = new AuthUser({
        token: localStorage.getItem("token"),
        userID: localStorage.getItem("userID"),
        userName: localStorage.getItem("userName"),
        email: localStorage.getItem("email") ? localStorage.getItem("email") : localStorage.getItem("userName"),
        name: localStorage.getItem("name"),
        googleCreated: localStorage.getItem("googleCreated"),
        role: localStorage.getItem("role"),
        termsAccepted: localStorage.getItem("termsAccepted"),
        businessID: localStorage.getItem("businessID"),
        totalRestaurants: localStorage.getItem("totalRestaurants"),
        defaultMenuID: localStorage.getItem("defaultMenuID"),
        hasPassword: localStorage.getItem("hasPassword"),
        usedFreeTrial: localStorage.getItem("usedFreeTrial"),
    });

    if (localStorage.getItem("subscriptionID")) {
        // @ts-ignore
        Auth.sub = {
            id: localStorage.getItem("subscriptionID"),
            code: localStorage.getItem("subscriptionCode"),
        };
    }

    return Auth;
}

export const GetSuperAuthObject = (json: any = null) => {
    if (json) {
        if (json.user) {
            if(json.user.token)
                localStorage.setItem("super-token", json.user.token);

            localStorage.setItem("super-userID", json.user.id);
            localStorage.setItem("super-userName", json.user.userName);
            localStorage.setItem("super-email", json.user.userName);
            localStorage.setItem("super-name", json.user.anU_NAME);

            if (json.user.aspNetRoles)
                localStorage.setItem("super-role", json.user.aspNetRoles.type);
        }
    }

    const Auth = {
        token: localStorage.getItem("super-token"),
        userID: localStorage.getItem("super-userID"),
        userName: localStorage.getItem("super-userName"),
        email: localStorage.getItem("super-email"),
        name: localStorage.getItem("super-name"),
        role: localStorage.getItem("super-role"),
    };

    return Auth;
}

export const AuthSuccessHandler = (json) => {
    const response = new AuthResponse()

    response.auth = GetAuthObject(json)

    if (response.auth.role === 'Adm') {
        // @ts-ignore
        response.superAuth = GetSuperAuthObject(json);
    }

    if (response.auth.role === 'Bow') {
        response.navigateTo = '/admin/menu/editor/' + response.auth.defaultMenuID;
        /*if(response.auth.totalRestaurants == "0")
            response.navigateTo = '/admin/setup' + window.location.search;
        else
            response.navigateTo = '/admin/menus';*/
    } else
        response.navigateTo = '/';

    return response;
}


export const AuthHandler = async (formData, TOSAccepted = true) => {
    let authResponse: AuthResponse | undefined = new AuthResponse()

    let response = await fetch(AppConfig.URL + "/Account/Login", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    });

    let json = await response.json();

    if (json.success) {
        authResponse = AuthSuccessHandler(json);
    } else {
        if (json.errorCode === UserErrorCodes.GOOGLE_EMAIL_NOT_VERIFIED) {
            authResponse.msg = TAuth[AppConfig.lang].GOOGLE_EMAIL_NOT_VERIFIED;
        } else if (json.errorCode === UserErrorCodes.GOOGLE_INFO_NOT_FOUND) {
            authResponse.msg = TAuth[AppConfig.lang].GOOGLE_INFO_NOT_FOUND;
        } else {
            if (TOSAccepted)
                authResponse = await SignUpHandler(formData)
        }
    }

    return authResponse;
}

export const SignUpHandler = async (formData) => {
    let response = await fetch(AppConfig.URL + "/Account/Signup", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    let json = await response.json();

    if (json.success) {
        gtag_signup_conversion()

        return AuthSuccessHandler(json);
    }
}

export const GoogleAuthHandler = async (googleResponse, type = 'BUSINESS') => {
    if (googleResponse.access_token) {
        let formData = {};

        formData['GoogleToken'] = googleResponse.access_token;
        formData['Type'] = type;

        return await AuthHandler(formData)
    }
}

export const AppleAuthHandler = async (appleResponse, type = 'BUSINESS') => {
    if (appleResponse.authorization.id_token) {
        let formData = {};

        formData['AppleToken'] = appleResponse.authorization.id_token;
        formData['Type'] = type;

        return await AuthHandler(formData)
    }
}

export const AppleSignUpHandler = async (appleResponse) => {
    //TODO: DELETE THIS
    console.log(appleResponse.authorization.id_token)
    if (appleResponse.authorization.id_token) {
        let formData = {};

        formData['AppleToken'] = appleResponse.authorization.id_token;
        formData['Type'] = 'BUSINESS';

        return await SignUpHandler(formData)
    }
}


class AuthResponse {
    auth: AuthUser | null | undefined
    navigateTo: string
    msg: string
}